import {login, logout, getInfo, saveCompanyInfo, changepassword} from '@/api/user'
import {getToken, setToken, removeToken}                         from '@/common/cookie'
// import router, { resetRouter } from '@/router'

const state = {
    token: getToken(),
    introduction: '',
    userInfo: {},
    patientInfo: {},
    prescriptionPic: null,
    //inObj: {},
    //inType: false,
    prescriptionid: '',
    camerasArr: [],// 摄像头组
    camerasIdx: '',// 当前摄像头
    remoteLeave: false,//远端流是否离开
    doctorInfo: {},
    pharmacistInfo: {},
}

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_DOCTORINFO: (state, val) => {
        state.doctorInfo = val
    },
    SET_PHARMACISTINFO:(state, val) => {
        state.pharmacistInfo = val
    },
    SET_REMOTELEAVE:(state, val) => {
        state.remoteLeave = val
    },
    SET_CAMERASARR: (state, camerasArr)=>{
        state.camerasArr = camerasArr
    },
    SET_CAMERASIDX: (state, val) => {
        state.camerasIdx = val
    },
    /*SET_INOBJ: (state, val) => {
        state.onObj = val
    },
    SET_INTYPE:(state, val) => {
        state.inType = val
    },*/
    SET_PRESCRIPTIONID:(state, val) => {
        state.prescriptionid = val
    },
    SET_PICTURE: (state, prescriptionPic) => {
        state.prescriptionPic = prescriptionPic
    },
    SET_USERINFO: (state, userInfo) => {
        state.userInfo = {...userInfo, isLogin: true}
    },
    SET_REMOVERINFO: (state, userInfo) => {
        state.userInfo = {
            isLogin: false,
            loginid: null,
            loginpwd: null,
        }
    },
    LOGINOUT: (state) => {
        state.userInfo = {}
        state.token = null
        removeToken()
    },
    SET_PATIENTINFO: (state, patientInfo) => {
        state.patientInfo = patientInfo
    },
    SET_INTRODUCTION: (state, introduction) => {
        state.introduction = introduction
    },
}

const actions = {
    // user login
    login({commit}, userInfo) {
        const {loginid, loginpwd} = userInfo
        console.log(userInfo)
        return new Promise((resolve, reject) => {
            login({loginid: loginid.trim(), loginpwd: loginpwd}).then(response => {
                const {data} = response
                commit('SET_USERINFO', data)
                commit('SET_TOKEN', data.userid)
                setToken(data.userid)
                resolve(data)
            }).catch(error => {
                console.log(error)
                /*todo*/
                reject(error)
            })
        })
    },
    saveCompanyInfo({commit}, companyInfo) {
        return new Promise((resolve, reject) => {
            saveCompanyInfo(companyInfo).then(response => {
                const {data} = response
                resolve(data)
            }).catch(error => {
                console.log(error)
                /*todo*/
                reject(error)
            })
        })
    },
    changepassword({commit}, passWord) {
        return new Promise((resolve, reject) => {
            changepassword(passWord).then(response => {
                const {data} = response
                resolve(data)
            }).catch(error => {
                console.log(error)
                /*todo*/
                reject(error)
            })
        })
    },

    // get user info

    getInfo({commit}, data) {
        return new Promise((resolve, reject) => {
            getInfo(data).then(response => {
                const {data} = response
                resolve(data)
            }).catch(error => {
                console.log(error)
                /*todo*/
                reject(error)
            })
        })
    },

    // user logout
    logout({commit, state, dispatch}) {
        return new Promise((resolve, reject) => {
            logout(state.token).then(() => {
                commit('SET_TOKEN', '')
                commit('SET_ROLES', [])
                removeToken()
                // reset visited views and cached views
                // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
                dispatch('tagsView/delAllViews', null, {root: true})
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },

    // remove token
    resetToken({commit}) {
        return new Promise(resolve => {
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            removeToken()
            resolve()
        })
    },

    // dynamically modify permissions
    // changeRoles({ commit, dispatch }, role) {
    //     return new Promise(async resolve => {
    //         const token = role + '-token'
    //
    //         commit('SET_TOKEN', token)
    //         setToken(token)
    //
    //         const { roles } = await dispatch('getInfo')
    //
    //         resetRouter()
    //
    //         // generate accessible routes map based on roles
    //         const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true })
    //
    //         // dynamically add accessible routes
    //         router.addRoutes(accessRoutes)
    //
    //         // reset visited views and cached views
    //         dispatch('tagsView/delAllViews', null, { root: true })
    //
    //         resolve()
    //     })
    // }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
